import { resolveLink as r, resolveIcon as o } from "../../../helpers/index.js";
const p = (e) => ({
  ...r(e.properties?.link),
  text: e.properties?.link && r(e.properties?.link[0]).text,
  icon: e.properties?.icon && o(e.properties?.icon),
  variant: e.properties?.buttonVariant && e.properties?.buttonVariant?.toLowerCase()
});
export {
  p as callToActionDeliveryApiParser
};
